// eslint-disable-next-line import/no-named-as-default
import sup from './support';

export default {
  getQuestions(data) {
    return sup.get('getQuestions', data);
  },
  buyquestions(data) {
    return sup.post('buy', data);
  },
  getIndexLayoutdata() { 
    return sup.get("getIndexLayoutdata");
  },
  searchExamList(data) { 
     return sup.get("searchExamList",data);
  }
};
